import styled from 'styled-components'

const IngredientList = styled.ul``

export default IngredientList
